import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { AuthService } from './auth.service';

/**
 * Service générique pour le téléchargement / impression des parties du dossier patient.
 * Centralise les appels liés à l'export (identité patient, données administratives, etc.)
 */
@Injectable({
  providedIn: 'root',
})
export class PatientRecordExportService extends BaseService {
  constructor(
    http: HttpClient,
    private authService: AuthService,
  ) {
    super(http);
  }

  /**
   * Exporte le document PDF d'identité du patient (interrogatoire médical / dossier patient).
   * GET /medical-records/export-patient-identity?passportNumber=...
   * Media type: application/pdf. Envoie Accept: application/pdf et Authorization: Bearer &lt;token&gt;.
   */
  exportPatientIdentityPdf(passportNumber: string): Observable<Blob> {
    const params = this.createParams({ passportNumber });
    const token = this.authService.getToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    });
    return this.http.get(
      `${this.baseUrl}/medical-records/export-patient-identity`,
      {
        headers,
        params,
        responseType: 'blob',
      },
    );
  }

  /**
   * Exporte le dossier médical complet (PDF) pour téléchargement / impression.
   * GET /medical-records/export-medical-record?passportNumber=...
   */
  exportMedicalRecordPdf(passportNumber: string): Observable<Blob> {
    const params = this.createParams({ passportNumber });
    const token = this.authService.getToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    });

    return this.http.get(`${this.baseUrl}/medical-records/export-medical-record`, {
      headers,
      params,
      responseType: 'blob',
    });
  }
}
